<script>

export default {
  props: ['item', 'roles'],
  data() {
    return {

      states: [
        {value: 'AL', name: 'Alabama'},
        {value: 'AK', name: 'Alaska'},
        {value: 'AZ', name: 'Arizona'},
        {value: 'AR', name: 'Arkansas'},
        {value: 'CA', name: 'California'},
        {value: 'CO', name: 'Colorado'},
        {value: 'CT', name: 'Connecticut'},
        {value: 'DE', name: 'Delaware'},
        {value: 'DC', name: 'District Of Columbia'},
        {value: 'FL', name: 'Florida'},
        {value: 'GA', name: 'Georgia'},
        {value: 'HI', name: 'Hawaii'},
        {value: 'ID', name: 'Idaho'},
        {value: 'IL', name: 'Illinois'},
        {value: 'IN', name: 'Indiana'},
        {value: 'IA', name: 'Iowa'},
        {value: 'KS', name: 'Kansas'},
        {value: 'KY', name: 'Kentucky'},
        {value: 'LA', name: 'Louisiana'},
        {value: 'ME', name: 'Maine'},
        {value: 'MD', name: 'Maryland'},
        {value: 'MA', name: 'Massachusetts'},
        {value: 'MI', name: 'Michigan'},
        {value: 'MN', name: 'Minnesota'},
        {value: 'MS', name: 'Mississippi'},
        {value: 'MO', name: 'Missouri'},
        {value: 'MT', name: 'Montana'},
        {value: 'NE', name: 'Nebraska'},
        {value: 'NV', name: 'Nevada'},
        {value: 'NH', name: 'New Hampshire'},
        {value: 'NJ', name: 'New Jersey'},
        {value: 'NM', name: 'New Mexico'},
        {value: 'NY', name: 'New York'},
        {value: 'NC', name: 'North Carolina'},
        {value: 'ND', name: 'North Dakota'},
        {value: 'OH', name: 'Ohio'},
        {value: 'OK', name: 'Oklahoma'},
        {value: 'OR', name: 'Oregon'},
        {value: 'PA', name: 'Pennsylvania'},
        {value: 'RI', name: 'Rhode Island'},
        {value: 'SC', name: 'South Carolina'},
        {value: 'SD', name: 'South Dakota'},
        {value: 'TN', name: 'Tennessee'},
        {value: 'TX', name: 'Texas'},
        {value: 'UT', name: 'Utah'},
        {value: 'VT', name: 'Vermont'},
        {value: 'VA', name: 'Virginia'},
        {value: 'WA', name: 'Washington'},
        {value: 'WV', name: 'West Virginia'},
        {value: 'WI', name: 'Wisconsin'},
        {value: 'WY', name: 'Wyoming'},
      ],
      
      timezones: [
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Phoenix',
        'America/Los_Angeles',
        'America/Anchorage',
        'America/Adak',
        'Pacific/Honolulu',
      ],
    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <div>

    <h5 class="mb-3 text-uppercase bg-gray-200 p-3"><Icon icon="ri:book-2-line"></Icon> Website details :</h5>
    <div class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company name :" v-model="item.title" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Website ID :" v-model="item.website_id" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Website domain :" Definition="This is used for previewing pages in the admin system as well as the domain used for images in emails sent by the system." v-model="item.website_domain" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" Title="Active :" :Options="[{name: 'Yes', value: 1},{name: 'No', value: 0}]" v-model="item.status" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" Title="Listings feed :" :Options="[{name: 'Listings', value: 'listings'},{name: 'MLS Listings', value: 'mls_listings'},{name: 'API Listings', value: 'api_listings'}]" v-model="item.feed_type"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company logo :" v-model="item.site_logo"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company favicon :" v-model="item.site_favicon"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="Phone" Title="Support phone :" v-model="item.site_phone"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Support email :" v-model="item.site_email"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company Facebook :" v-model="item.site_facebook"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company Instagram :" v-model="item.site_instagram"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company Twitter :" v-model="item.site_twitter"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company YouTube :" v-model="item.site_youtube"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company address :" v-model="item.site_address"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company city :" v-model="item.site_city"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" Title="Company state :" :Options="states" v-model="item.site_state"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company zip code :" v-model="item.site_zip_code"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company latitude :" v-model="item.site_latitude"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Company longitude :" v-model="item.site_longitude"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" Title="Company timezone :" :Options="timezones" v-model="item.site_timezone"></w-field>
      </div>
      <div class="col-sm-12">
        <label>Mail recipients :</label>
        <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.mail_recipients">
          <transition-group tag="div">
            <div v-for="(recip, recip_i) in item.mail_recipients" :key="'a'+recip_i" class="input-group mb-1">
              <input type="text" class="form-control" placeholder="Recipients email" v-model="item.mail_recipients[recip_i]">
              <div class="input-group-append">
                <button class="btn btn-white" type="button" v-tippy content="Delete recipient" @click="item.mail_recipients.splice(recip_i, 1)"><Icon icon="ri:delete-bin-line" /></button>
                <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill" /></button>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="mb-2">
          <button class="btn btn-sm btn-primary" type="button" @click="item.mail_recipients.push('')"><Icon icon="ri:add-line" height="18" /> Add recipient</button>
        </div>
      </div>
    </div>

    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Code snippets :</h5>
    <div class="form-group">
      <label>Header snippets :</label>
      <component is="PrismEditorMain" v-model="item.site_header_snippets"></component>
    </div>
    <div class="form-group">
      <label>Footer snippets :</label>
      <component is="PrismEditorMain" v-model="item.site_footer_snippets"></component>
    </div>

    <component v-if="item.site_navbar && item.site_navbar.type" is="w-site-navbar" type="editor" :pc="item.site_navbar" :website="item" :roles="roles"></component>

    <component v-if="item.site_footer && item.site_footer.type" is="w-site-footer" type="editor" :pc="item.site_footer" :website="item" :roles="roles"></component>

    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Blog settings :</h5>
    <label>Blog categories :</label>
    <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.blog_categories">
      <transition-group tag="div">
        <div v-for="(bcat, bcat_i) in item.blog_categories" :key="'a'+bcat_i" class="input-group mb-1">
          <input type="text" class="form-control" placeholder="Category..." v-model="item.blog_categories[bcat_i]">
          <div class="input-group-append">
            <button class="btn btn-white" type="button" v-tippy content="Delete" @click="item.blog_categories.splice(bcat_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
            <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="mb-2">
      <button class="btn btn-sm btn-primary" type="button" @click="item.blog_categories.push('')"><Icon icon="ri:add-line" height="18"></Icon> Add category</button>
    </div>

    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> FAQ settings :</h5>
    <label>FAQ categories :</label>
    <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.faq_categories">
      <transition-group tag="div">
        <div v-for="(fcat, fcat_i) in item.faq_categories" :key="'a'+fcat_i" class="input-group mb-1">
          <input type="text" class="form-control" placeholder="Category..." v-model="item.faq_categories[fcat_i]">
          <div class="input-group-append">
            <button class="btn btn-white" type="button" v-tippy content="Delete" @click="item.faq_categories.splice(fcat_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
            <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="mb-2">
      <button class="btn btn-sm btn-primary" type="button" @click="item.faq_categories.push('')"><Icon icon="ri:add-line" height="18"></Icon> Add category</button>
    </div>

    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Vendor settings :</h5>
    <label>Vendor locations :</label>
    <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.vendor_locations">
      <transition-group tag="div">
        <div v-for="(vloc, vloc_i) in item.vendor_locations" :key="'a'+vloc_i" class="input-group mb-1">
          <input type="text" class="form-control" placeholder="Category..." v-model="item.vendor_locations[vloc_i]">
          <div class="input-group-append">
            <button class="btn btn-white" type="button" v-tippy content="Delete" @click="item.vendor_locations.splice(vloc_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
            <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="mb-2">
      <button class="btn btn-sm btn-primary" type="button" @click="item.vendor_locations.push('')"><Icon icon="ri:add-line" height="18"></Icon> Add location</button>
    </div>
    <label>Vendor categories :</label>
    <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.vendor_categories">
      <transition-group tag="div">
        <div v-for="(vcat, vcat_i) in item.vendor_categories" :key="'a'+vcat_i" class="input-group mb-1">
          <input type="text" class="form-control" placeholder="Category..." v-model="item.vendor_categories[vcat_i]">
          <div class="input-group-append">
            <button class="btn btn-white" type="button" v-tippy content="Delete" @click="item.vendor_categories.splice(vcat_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
            <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="mb-2">
      <button class="btn btn-sm btn-primary" type="button" @click="item.vendor_categories.push('')"><Icon icon="ri:add-line" height="18"></Icon> Add category</button>
    </div>
    

    <div class="clearfix mt-3"></div>

  </div>
</template>
